import React, { useState, useEffect } from 'react';
import { TimePicker, Checkbox } from 'antd';
import moment from 'moment';
import { ClockCircleOutlined } from '@ant-design/icons';

export const TimeRangePickerWith24Hours = ({ value = {}, onChange, name, ...props }) => {
	const [checked, setChecked] = useState(false);
	const [times, setTimes] = useState({
		from: value.from || null,
		to: value.to || null,
	});

	// Helper: determine if times span a full day (≈ 24 hours)
	const isFullDay = (from, to) => {
		if (!from || !to) return false;
		const start = moment(from);
		const end = moment(to);
		const diff = end.diff(start, 'minutes');
		// 24 hours = 1440 minutes; allow 16-min tolerance
		return diff >= 1424; // (1440 - 16)
	};

	// Initialize state from incoming props
	useEffect(() => {
		const newTimes = {
			from: value.from || null,
			to: value.to || null,
		};
		setTimes(newTimes);

		// Check if default times represent full-day
		if (isFullDay(newTimes.from, newTimes.to)) {
			setChecked(true);
		} else {
			setChecked(false);
		}
	}, [value.from, value.to]);

	const triggerChange = (changedValue) => {
		const newValue = { ...times, ...changedValue };
		setTimes(newValue);
		onChange(newValue); // notify Form.Item
	};

	const handleFromChange = (val) => triggerChange({ from: val });
	const handleToChange = (val) => triggerChange({ to: val });

	const setFullDay = () => {
		const start = moment('00:00', 'HH:mm');
		const end = moment('23:59', 'HH:mm');
		triggerChange({ from: start, to: end });
	};

	const clearFullDay = () => {
		triggerChange({ from: null, to: null });
	};

	const handleToggle = (e) => {
		const isChecked = e.target.checked;
		setChecked(isChecked);
		if (isChecked) setFullDay();
		else clearFullDay();
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
			{checked ? (
				<div
					onClick={() => setChecked(false)}
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						fontSize: 14,
						width: 220,
					}}
					className="ant-picker"
				>
					<span style={{ marginRight: 8 }}>24 hours (All day)</span>
					<span style={{ color: 'rgba(0, 0, 0, 0.25)' }}>
						<ClockCircleOutlined />
					</span>
				</div>
			) : (
				<>
					<TimePicker
						value={times.from}
						onChange={handleFromChange}
						name={`${name}-from`}
						placeholder="Open"
						use12Hours
						format="h:mm a"
						showNow={false}
						minuteStep={15}
						renderExtraFooter={() => (
							<div
								onMouseDown={(e) => e.stopPropagation()}
								onClick={(e) => e.stopPropagation()}
								style={{ textAlign: 'left', marginLeft: -8, marginRight: -8 }}
							>
								<Checkbox checked={checked} onChange={handleToggle} style={{ fontSize: 12 }}>
									Open all day (24 hours)
								</Checkbox>
							</div>
						)}
						{...props}
					/>
					<span>-</span>
					<TimePicker
						placeholder="Close"
						value={times.to}
						onChange={handleToChange}
						name={`${name}-to`}
						use12Hours
						format="h:mm a"
						minuteStep={15}
						showNow={false}
						{...props}
					/>
				</>
			)}
		</div>
	);
};
